import { useSelector } from 'react-redux';
import { staticComponentValueConverter } from '../StaticComponentValues';

const Popup_2 = ({ item }) => {
  const staticValues = useSelector(state => state.themeSlice?.staticValues);
  const customization = staticComponentValueConverter(item?.customization);

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        width: '100%',
        justifyContent: 'center',
        alignItems: 'center',
        paddingLeft: staticValues[15],
        paddingRight: staticValues[15],
      }}
    >
      <div
        style={{
          width: '100%',
          padding: customization?.padding,
          borderWidth: customization?.isShowBorder ? 1 : 0,
          borderStyle: 'solid',
          borderColor: customization?.borderColor,
          borderRadius: customization?.popupBorderRadius,
          display: 'flex',
          flexDirection: 'column',
          gap: staticValues[10],
          backgroundColor: customization?.backgroundColor,
        }}
      >
        <div style={{ position: 'relative' }}>
          <div
            className="absolute top-3 right-3 py-1 px-2"
            style={{
              borderRadius: 5,
              opacity: 0.2,
              backgroundColor: 'white',
            }}
          >
            <svg
              fill="#000000"
              width="20px"
              height="20px"
              viewBox="-0.088 0 0.475 0.475"
              xmlns="http://www.w3.org/2000/svg"
              class="cf-icon-svg"
            >
              <path d="M0.285 0.341A0.026 0.026 0 0 1 0.248 0.378L0.15 0.279 0.052 0.378a0.026 0.026 0 1 1 -0.036 -0.036l0.098 -0.098L0.015 0.145a0.026 0.026 0 1 1 0.036 -0.036L0.15 0.207l0.098 -0.098a0.026 0.026 0 0 1 0.036 0.036L0.186 0.243z" />
            </svg>
          </div>
          <img
            src={customization?.popupImage}
            style={{
              width: '100%',
              borderRadius: customization?.imageBorderRadius,
            }}
          />
        </div>
        {customization?.isShowPopupButton && (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              width: '100%',
            }}
          >
            {customization?.buttonCount === 'widget.Popup.buttonCount' && (
              <>
                <div
                  style={{
                    width: `${customization?.buttonWidths}%`,
                    paddingRight: 5,
                    overflow: 'hidden',
                  }}
                >
                  <div
                    className="truncate"
                    style={{
                      paddingTop: customization?.buttonVerticalPadding + 'px',
                      paddingBottom: customization?.buttonVerticalPadding + 'px',
                      paddingLeft: staticValues[10],
                      paddingRight: staticValues[10],
                      borderRadius: customization?.firstButtonBorderRadius,
                      fontSize: customization?.firstButtonTextSize,
                      backgroundColor: customization?.firstButtonBackgroundColor,
                      color: customization.firstButtonTextColor,
                      fontWeight: customization?.firstButtonTextWeight,
                      borderWidth: 1,
                      borderStyle: 'solid',
                      borderColor: customization?.firstButtonBorderColor,
                    }}
                  >
                    {customization?.firstButtonText}
                  </div>
                </div>
                <div
                  style={{
                    width: `${100 - customization?.buttonWidths}%`,
                    paddingLeft: 5,
                    overflow: 'hidden',
                  }}
                >
                  <div
                    className="truncate"
                    style={{
                      paddingTop: customization?.buttonVerticalPadding + 'px',
                      paddingBottom: customization?.buttonVerticalPadding + 'px',
                      paddingLeft: staticValues[10],
                      paddingRight: staticValues[10],
                      borderRadius: customization?.secondButtonBorderRadius,
                      backgroundColor: customization?.secondButtonBackgroundColor,
                      fontSize: customization?.secondButtonTextSize,
                      color: customization.secondButtonTextColor,
                      fontWeight: customization?.secondButtonTextWeight,
                      borderWidth: 1,
                      borderStyle: 'solid',
                      borderColor: customization?.secondButtonBorderColor,
                    }}
                  >
                    {customization?.secondButtonText}
                  </div>
                </div>
              </>
            )}
            {customization?.buttonCount !== 'widget.Popup.buttonCount' && (
              <div
                style={{
                  display: 'flex',
                  justifyContent:
                    customization?.singleButtonPosition === 'left'
                      ? 'flex-start'
                      : customization?.singleButtonPosition === 'right'
                      ? 'flex-end'
                      : 'center',
                  width: '100%',
                }}
              >
                <div
                  style={{
                    width: `${customization?.buttonWidths}%`,
                    paddingRight: 5,
                    overflow: 'hidden',
                  }}
                >
                  <div
                    className="truncate"
                    style={{
                      paddingTop: customization?.buttonVerticalPadding + 'px',
                      paddingBottom: customization?.buttonVerticalPadding + 'px',
                      paddingLeft: staticValues[10],
                      paddingRight: staticValues[10],
                      borderRadius: customization?.firstButtonBorderRadius,
                      fontSize: customization?.firstButtonTextSize,
                      backgroundColor: customization?.firstButtonBackgroundColor,
                      color: customization.firstButtonTextColor,
                      fontWeight: customization?.firstButtonTextWeight,
                      borderWidth: 1,
                      borderStyle: 'solid',
                      borderColor: customization?.firstButtonBorderColor,
                    }}
                  >
                    {customization?.firstButtonText}
                  </div>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default Popup_2;
